import CurrencyForm from "../Form/CurrencyForm";

const CurrencyConverter = () => {
  return (
    <main>
      <div className="container text-center my-5 py-5">
        <CurrencyForm />
      </div>
    </main>
  );
};

export default CurrencyConverter;
